import { useTranslation } from 'react-i18next';
import { FollowUpCompletedSelectBox } from 'components/molecules/followup-completed-select-box';

import s from './styles.module.scss';

import type { TTablePrefix } from 'infrastructure/interfaces';
import type { FC } from 'react';
import type { IFollowUpCompletedItem } from 'infrastructure/data-sources/followup-completed';

interface FollowUpCompletedSelectBoxProps {
  cyPrefix?: string;
  tablePrefix: TTablePrefix;
  value?: IFollowUpCompletedItem['id'];
  updateFilter: <T>(newFilter: Partial<T>) => void;
}
export const FollowUpCompletedSelect: FC<FollowUpCompletedSelectBoxProps> = ({
  cyPrefix,
  value,
  tablePrefix,
  updateFilter,
}) => {
  const { t } = useTranslation();
  const dataCy = `${cyPrefix}-completed`;

  return (
    <div className={s['select-wrapper-calls']}>
      <label className={s['select-label']}>
        <span>{t('labels.followUpCompleted')}:</span>
        <FollowUpCompletedSelectBox
          value={value}
          maxWidth="450px"
          dataCy={dataCy}
          onChange={(v) => {
            updateFilter({
              [`${tablePrefix}completed`]: v === null ? v : String(v),
              [`${tablePrefix}page`]: undefined,
            });
          }}
          allowClear
          withNone
        />
      </label>
    </div>
  );
};
